/**
 * Visit type labels, mirroring the backend's src/services/shared/visitLabels.js.

 */
// Midnight Malaysia time, 25 Sep 2026.
const DEFAULT_OUTLET_LABEL_CUTOVER_AT = "2026-09-25T00:00:00+08:00";

let cachedCutover;

const getOutletLabelCutoverAt = () => {
  if (cachedCutover !== undefined) return cachedCutover;

  const raw = process.env.REACT_APP_OUTLET_LABEL_CUTOVER_AT;
  const candidate = raw && String(raw).trim() ? String(raw).trim() : null;
  const parsed = new Date(candidate || DEFAULT_OUTLET_LABEL_CUTOVER_AT);

  cachedCutover = Number.isNaN(parsed.getTime())
    ? new Date(DEFAULT_OUTLET_LABEL_CUTOVER_AT)
    : parsed;

  return cachedCutover;
};

/**
 * Whether a session predates the "Outlet Visit" -> "Outlet" rename.
 */
export const isLegacyOutletLabel = (checkedInAt) => {
  if (!checkedInAt) return false;
  const checkedIn = new Date(checkedInAt);
  if (Number.isNaN(checkedIn.getTime())) return false;
  return checkedIn < getOutletLabelCutoverAt();
};

/**
 * i18n key for a non-roadshow session's label, era-aware.
 * Note: `admin.sessions.outlet` is the table column header ("Location"), so the
 * visit-type label uses its own key.
 * @returns {"admin.sessions.outletCheckIn"|"admin.sessions.outletLabel"}
 */
export const outletLabelKey = (checkedInAt) =>
  isLegacyOutletLabel(checkedInAt)
    ? "admin.sessions.outletCheckIn"
    : "admin.sessions.outletLabel";
